import { Accordion } from '../../js/components/accordion';

document.addEventListener('DOMContentLoaded', function () {

    const details = document.querySelectorAll('.block-accordion details');

    details.forEach((targetDetail, t) => {
        new Accordion(targetDetail);

        if ( t == 0 ) {
            targetDetail.open = true;
        }

        targetDetail.addEventListener('click', () => {
            details.forEach((detail) => {
                if (detail !== targetDetail) {
                    detail.removeAttribute('open');
                }
            });
        });
    });



});
